export enum DeliveryMethod {
  Direct,
  Transit,
}

export const DeliveryMethodList = [
  {
    label: '中转',
    value: DeliveryMethod.Transit,
  },
  {
    label: '直送',
    value: DeliveryMethod.Direct,
  },
];

export const DeliveryMethodOptions = [
  {
    content: '中转',
    key: DeliveryMethod.Transit,
    value: DeliveryMethod.Transit,
  },
  {
    content: '直送',
    key: DeliveryMethod.Direct,
    value: DeliveryMethod.Direct,
  },
];

export enum TakeTypeEnum {
  'ALL' = -1,
  'COMPANY',
  'GROUP',
}

export const TakeTypeList = [
  { value: TakeTypeEnum.ALL, label: '全部' },
  { value: TakeTypeEnum.COMPANY, label: '企业' },
  { value: TakeTypeEnum.GROUP, label: '饭圈' },
];

export enum DayTypeEnum {
  'WorkDay' = 1,
  'Holiday',
}

export interface DispatchRoute {
  dispatchRouteId: string;
  dispatchRouteName: string;
}
